import { render, staticRenderFns } from "./tro-choi-so.vue?vue&type=template&id=b70aed26&"
import script from "./tro-choi-so.vue?vue&type=script&lang=js&"
export * from "./tro-choi-so.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports